import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { toPascalCase } from '@cli-utils/text.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderMultiRelationshipFieldActionButtonsTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-multi-relationship-field.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'

export function renderMultiRelationshipField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string,
  displayField: string,
  secondaryDisplayField: string,
  dataArray: string,
  relSingular: string,
  context: FieldRenderContext
): string {
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)
  return renderMultiRelationshipFieldActionButtonsTemplate({
    indent: indent,
    fieldName: field.name,
    formItemProps: formItemProps(field, 'flex flex-col'),
    labelWithDescription: labelWithDescription(formLabel(field, label), hintJSX, `${indent}      `),
    toPascalCase: toPascalCase(field.name),
    toLowerCase: label.toLowerCase(),
    relSingular: relSingular,
    dataArray: dataArray,
    displayField: displayField,
    secondaryDisplayField: secondaryDisplayField,
    defaultValueFromHandlerContent: defaultValueFromHandler
      ? `${indent}                        const nextValue = isSelected\n${indent}                          ? current.filter((id: string) => id !== item.id)\n${indent}                          : [...current, item.id]\n${indent}                        ${defaultValueFromHandler}(nextValue)\n${indent}                        formField.onChange(nextValue)`
      : `${indent}                        formField.onChange(isSelected\n${indent}                          ? current.filter((id: string) => id !== item.id)\n${indent}                          : [...current, item.id])`
  })
}
